// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiRoute from "lumi-rescript/lib/es6/src/LumiRoute.res.js";
import * as M23f$Linear from "lumi-linear/lib/es6/src/M23f.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Translation$LumiI18n from "lumi-i18n/lib/es6/src/Translation.res.js";

let jsonCodec = Jzon.object3(param => [
  param.map,
  param.transform,
  param.selection
], param => ({
  TAG: "Ok",
  _0: {
    map: param[0],
    transform: param[1],
    selection: param[2]
  }
}), Jzon.field("map", Document$LumiStore.Key.jsonCodec()), Jzon.field("transform", M23f$Linear.jsonCodec), Jzon.field("selection", Jzon.nullable(Document$LumiStore.Key.jsonCodec())));

let ViewFacilityMap = {
  jsonCodec: jsonCodec
};

function stringCodec_toString(v) {
  if (v === "CurrentOccupation") {
    return "current-occupation";
  } else {
    return "abandoned-vehicles";
  }
}

function stringCodec_fromString(s) {
  switch (s) {
    case "abandoned-vehicles" :
      return "AbandonedVehicles";
    case "current-occupation" :
      return "CurrentOccupation";
    default:
      return;
  }
}

let stringCodec = {
  toString: stringCodec_toString,
  fromString: stringCodec_fromString
};

let jsonCodec$1 = LumiJzon.stringCodec(stringCodec);

function translate(locale, entry) {
  switch (locale) {
    case "DEU" :
      if (entry === "CurrentOccupation") {
        return "Aktuelle Belegung";
      } else {
        return "Verlassene Fahrzeuge";
      }
    case "ENG" :
      if (entry === "CurrentOccupation") {
        return "Current occupation";
      } else {
        return "Abandoned vehicles";
      }
    case "FRA" :
      if (entry === "CurrentOccupation") {
        return "Occupation actuelle";
      } else {
        return "Véhicules abandonnés";
      }
    case "NLD" :
      if (entry === "CurrentOccupation") {
        return "Huidige bezetting";
      } else {
        return "Weesvoertuigen";
      }
    case "SLK" :
      if (entry === "CurrentOccupation") {
        return "Aktuálna obsadenosť";
      } else {
        return "Opustené vozidlá";
      }
    default:
      return;
  }
}

let T = Translation$LumiI18n.MakeProvider({
  defaultLocale: "ENG",
  translate: translate
});

let Tab = {
  $$default: "CurrentOccupation",
  stringCodec: stringCodec,
  jsonCodec: jsonCodec$1,
  T: T
};

let $$default = {
  map: undefined,
  tab: "CurrentOccupation"
};

let jsonCodec$2 = Jzon.object2(param => [
  param.map,
  param.tab
], param => ({
  TAG: "Ok",
  _0: {
    map: param[0],
    tab: param[1]
  }
}), Jzon.field("map", Jzon.nullable(jsonCodec)), Jzon.field("tab", jsonCodec$1));

let $$Map = {
  ViewFacilityMap: ViewFacilityMap,
  Tab: Tab,
  $$default: $$default,
  jsonCodec: jsonCodec$2
};

let $$default$1 = {
  TAG: "Map",
  _0: $$default
};

let jsonCodec$3 = LumiJzon.taggedVariantOptionalContents(value => {
  if (typeof value !== "object") {
    return [
      "statistics",
      undefined
    ];
  } else {
    return [
      "map",
      Jzon.encodeWith(value._0, jsonCodec$2)
    ];
  }
}, pair => {
  let other = pair[0];
  switch (other) {
    case "map" :
      let json = pair[1];
      if (json !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$2), m => ({
          TAG: "Map",
          _0: m
        }));
      } else {
        return {
          TAG: "Error",
          _0: {
            NAME: "UnexpectedJsonValue",
            VAL: [
              [],
              other
            ]
          }
        };
      }
    case "statistics" :
      return {
        TAG: "Ok",
        _0: "Statistics"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            other
          ]
        }
      };
  }
}, undefined, undefined);

function sameTab(a, b) {
  if (typeof a !== "object") {
    return typeof b !== "object";
  } else if (typeof b !== "object") {
    return false;
  } else {
    return a._0.tab === b._0.tab;
  }
}

function translate$1(locale, entry) {
  if (typeof entry === "object") {
    return T.translate(locale, entry._0.tab);
  }
  switch (locale) {
    case "DEU" :
      return "Statistiken";
    case "ENG" :
      return "Statistics";
    case "FRA" :
      return "Statistiques";
    case "NLD" :
      return "Statistieken";
    case "SLK" :
      return "Štatistiky";
    default:
      return;
  }
}

let T$1 = Translation$LumiI18n.MakeProvider({
  defaultLocale: "ENG",
  translate: translate$1
});

let Application = {
  $$default: $$default$1,
  jsonCodec: jsonCodec$3,
  sameTab: sameTab,
  T: T$1
};

let include = LumiRoute.Make({
  $$default: $$default$1,
  jsonCodec: jsonCodec$3
});

let jsonCodec$4 = include.jsonCodec;

let stringCodec$1 = include.stringCodec;

let toString = include.toString;

let fromString = include.fromString;

let parseUrl = include.parseUrl;

let useRoute = include.useRoute;

export {
  $$Map,
  Application,
  jsonCodec$4 as jsonCodec,
  stringCodec$1 as stringCodec,
  toString,
  fromString,
  parseUrl,
  useRoute,
}
/* jsonCodec Not a pure module */
